<template>
    <div class="Category">
        <div class="Category_inner">
            <div class="Select">
                <!--<el-select v-model="searchInfo.for" placeholder="请选择类型" size="medium"-->
                           <!--style="width: 180px;margin-right: 5px" clearable>-->
                    <!--<el-option-->
                            <!--v-for="item in options"-->
                            <!--:key="item.value"-->
                            <!--:label="item.label"-->
                            <!--:value="item.value">-->
                    <!--</el-option>-->
                <!--</el-select>-->
                <el-input size="medium" style="width: 180px;margin-right: 5px" v-model="searchInfo.title"
                          placeholder="请输入内容"></el-input>
                <el-button type="primary" size="medium" @click="GetVideopageList">查询
                </el-button>
                <el-button style="float: right" type="primary" size="medium" @click="add">新增</el-button>

            </div>
            <div>
                <el-table :data="pageList" style="width: 100%" max-height="520px">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="videoId" label="videoId" v-if="true" align="center">
                    </el-table-column>
                    <el-table-column prop="title" :show-overflow-tooltip="true" sortable label="视频名称"   align="center">
                    </el-table-column>
                    <el-table-column prop="posterSrc" label="视频封面" width="200px" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.cover" style="width:60px">
                        </template>
                    </el-table-column>
                    <el-table-column prop="category" label="类型名称"  align="center">
                    </el-table-column>
                    <el-table-column prop="listOrder" label="排序" align="center" width="200px">
                    </el-table-column>
                    <el-table-column prop="for" label="患者/家属" align="center" width="200px">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="250">
                        <template slot-scope="scope">
                            <el-button class="edit_btn" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>

                            <!--<el-button class="del_btn" size="mini" @click="del(scope)">删除</el-button>-->
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <!--弹框-->
            <div>
                <el-dialog  :title="title" :visible.sync="isShow"
                        width="800px"  top="20vh" custom-class="pop-dialog" :before-close="oncancel">
                    <el-form :model="formData" label-position="right" label-width="120px" :rules="rules" ref="formData"
                             class="demo-ruleForm" style="width: 100%">

                        <el-form-item label="标题: " prop="title">
                            <el-input size="small" v-model="formData.title"></el-input>
                        </el-form-item>

                        <el-form-item label="排序: " prop="listOrder">
                            <el-input size="small" v-model="formData.listOrder"></el-input>
                        </el-form-item>

                        <el-form-item label="详细描述: " prop="description">
                            <el-input size="small" v-model="formData.description"></el-input>
                        </el-form-item>

                        <el-form-item label="类型: " style="margin-top: 16px">
                            <el-select
                                    v-model="formData.category"
                                    placeholder="请选择"
                                    size="small"
                                    value-key="id">
                                <el-option
                                        v-for="item in categoryList"
                                        :key="item.text"
                                        :label="item.text"
                                        :value="item.text"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="家属/患者: " style="margin-top: 16px">
                            <el-select
                                    v-model="formData.for"
                                    placeholder="请选择"
                                    size="small"
                                    value-key="id">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="上传图片:" prop="posterSrc" class="higher">
                            <upload ref="postUpload" :defaultUrl.sync="formData.posterSrc" style="margin-left: 100px"/>
                        </el-form-item>

                        <el-form-item label="上传视频: " prop="videoSrc" class="higher">
                            <upload1 ref="postUpload1" :isVideo="2"
                                     :defaultUrl.sync="formData.videoSrc" style="margin-left: 100px"/>
                        </el-form-item>

                    </el-form>
                    <div style="margin-top: 25px; width: 100%; text-align: center">
                        <el-button
                                @click="oncancel"
                                size="small"
                                class="cancel"
                                style="background: rgba(231, 231, 231, 1)"
                        >取消
                        </el-button>
                        <el-button
                                type="primary"
                                @click="onSave"
                                size="small"
                                class="onSave"
                                style="background: rgba(201, 160, 108, 1)"
                        >确 定
                        </el-button>
                    </div>
                    <br/>
                </el-dialog>
            </div>

            <!--<div>-->
                <!--<el-dialog  :title="title" :visible.sync="isShowedit"-->
                            <!--width="800px"  top="20vh" custom-class="pop-dialog" :before-close="cancel">-->
                    <!--<el-form :model="formData" label-position="right" label-width="120px" :rules="rules" ref="formData"-->
                             <!--class="demo-ruleForm" style="width: 100%">-->

                        <!--<el-form-item label="标题: " prop="title">-->
                            <!--<el-input size="small" v-model="formData.title"></el-input>-->
                        <!--</el-form-item>-->

                        <!--<el-form-item label="排序: " prop="listOrder">-->
                            <!--<el-input size="small" v-model="formData.listOrder"></el-input>-->
                        <!--</el-form-item>-->

                        <!--<el-form-item label="详细描述: " prop="description">-->
                            <!--<el-input size="small" v-model="formData.description"></el-input>-->
                        <!--</el-form-item>-->
                        <!--<el-form-item label="家属/患者: " style="margin-top: 16px">-->
                            <!--<el-select-->
                                    <!--v-model="formData.for"-->
                                    <!--placeholder="请选择"-->
                                    <!--size="small"-->
                                    <!--value-key="id">-->
                                <!--<el-option-->
                                        <!--v-for="item in options"-->
                                        <!--:key="item.value"-->
                                        <!--:label="item.label"-->
                                        <!--:value="item.value"-->
                                <!--&gt;-->
                                <!--</el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->

                        <!--<el-form-item label="上传图片:" prop="posterSrc" class="higher">-->
                            <!--<upload ref="postUpload" :defaultUrl.sync="formData.posterSrc" style="margin-left: 100px"/>-->
                        <!--</el-form-item>-->

                        <!--<el-form-item label="上传视频: " prop="videoSrc" class="higher">-->
                            <!--<upload1 ref="postUpload1" :isVideo="2"-->
                                     <!--:defaultUrl.sync="formData.videoSrc" style="margin-left: 100px"/>-->
                        <!--</el-form-item>-->

                    <!--</el-form>-->
                    <!--<div style="margin-top: 25px; width: 100%; text-align: center">-->
                        <!--<el-button-->
                                <!--@click="cancel"-->
                                <!--size="small"-->
                                <!--class="cancel"-->
                                <!--style="background: rgba(231, 231, 231, 1)"-->
                        <!--&gt;取消-->
                        <!--</el-button>-->
                        <!--<el-button-->
                                <!--type="primary"-->
                                <!--@click="onSaveedit"-->
                                <!--size="small"-->
                                <!--class="onSave"-->
                                <!--style="background: rgba(201, 160, 108, 1)"-->
                        <!--&gt;确 定-->
                        <!--</el-button>-->
                    <!--</div>-->
                    <!--<br/>-->
                <!--</el-dialog>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import upload1 from 'components/FileUpload2'
    import upload from 'components/FileUpload'

    import {GetVideopageList} from '@/assets/js/api'
    import {GetcategorybyformovieList} from '@/assets/js/api'
    import {SaveVideo} from '@/assets/js/api'
    import {SaveeditVideo} from '@/assets/js/api'

    export default {
        data: () => ({
            image: '',
            searchInfo: {
                title: ''
            },
            pageList: [],
            categoryList: [],
            options: [
                {
                    value: '患者',
                    label: '患者'
                },
                {
                    value: '家属',
                    label: '家属'
                }
            ],
            // 弹窗
            isShow: false,
            isShowedit: false,
            title: '',
            formData: {
                videoId:0,
                category: '',
                title: '',
                description: '',
                videoSrc: '',
                posterSrc: '',
                for: '',
                listOrder: '',
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: '请输入标题',
                        trigger: 'change',
                    },
                ],
                listOrder: [
                    {
                        required: true,
                        message: '请输入排序数字',
                        trigger: 'change',
                    },
                ],

            },
            // 首页优先显示开关
            Id: 0,
            IsOnline: false
        }),
        components: {
            upload, upload1,
        },
        created() {
            this.GetVideopageList()
            this.GetcategorybyformovieList()
        },

        mounted() {

        },
        methods: {
            // 获取数据
            GetVideopageList() {
                console.log('111111111111'+this.searchInfo.for)
                GetVideopageList(this.searchInfo).then(res => {
                    //console.log('22222222222222---'+res.data.videoArr)
                    //if (res.data.ReturnCode == 0) {
                    this.pageList=null;
                    this.pageList = res.data.videoArr
                    // } else {
                    //     this.CategoryList = []
                    // }
                })
            },
            // 获取movie类型数据
            GetcategorybyformovieList() {
                console.log('111111111111'+this.searchInfo.for)
                GetcategorybyformovieList().then(res => {
                    //if (res.data.ReturnCode == 0) {
                    this.categoryList = res.data.categorys
                    // } else {
                    //     this.CategoryList = []
                    // }
                })
            },
            onReset() {
                this.$refs.postUpload.clearFiles()
                this.$refs.postUpload1.clearFiles()
                this.$refs.fm.resetFields()
            },
            add() {
                this.isShow = true
                this.title = '新增'
            },
            batchUpload(refs) {
                let promiseArr = [];
                refs.map(r => {
                    promiseArr.push(
                        new Promise((resolve, reject) => {
                            r.startupload(() => {
                                resolve();
                            });
                        })
                    );
                });
                return Promise.all(promiseArr);
            },
            batchUpload1(refs) {
                let promiseArr = [];
                refs.map(r => {
                    promiseArr.push(
                        new Promise((resolve, reject) => {
                            r.startupload(() => {
                                resolve();
                            });
                        })
                    );
                });
                return Promise.all(promiseArr);
            },
            onSave() {
                this.$refs.formData.validate((valid) => {
                    if (!valid) return false
                    this.batchUpload([this.$refs.postUpload1]).then(() => {
                        this.batchUpload([this.$refs.postUpload]).then(() => {
                            //console.log('11111111111111111-------'+this.formData.posterSrc)
                            //console.log('2222222222222-------'+this.formData.videoId)
                            //console.log('3333333333333-------'+this.formData)
                            if (typeof this.formData.videoId === 'undefined') {
                                this.formData.videoId=0;
                            }
                            SaveVideo(this.formData).then((res) => {
                                console.log('resresresresres-------'+res.data.code)
                                if (res.data.code!=-1) {
                                    this.$message.success('保存成功')
                                    this.oncancel()
                                } else {
                                    this.$message.success('保存失败,检查是否名称重复和没有填全资料')
                                }
                            })
                        })
                    })
                })
            },

            oncancel() {
                this.isShow=false
                this.isShowedit=false
                this.formData = {
                    title: '',
                    description: '',
                    videoSrc: '',
                    posterSrc: '',
                    for: '',
                    listOrder: '',
                }
                this.resetForm('formData')
            },
            //编辑
            handleUpdate(row) {
                this.isShow = true;
                this.title = '编辑'
                this.formData = row
            }
        },

    }
</script>

<style lang="scss" scoped>
    .Category {
        padding: 20px 20px 10px;
        .Category_inner {
            padding: 20px 30px 30px 30px;
            width: calc(100% - 60px);
            min-height: calc(100vh - 155px);
            background: #fff;
            display: flex;
            flex-direction: column;
            font-size: 12px !important;
            .breadcrumb {
                align-items: center;
                justify-content: center;
                .el-breadcrumb {
                    font-size: 15px;
                    line-height: 2;
                }
            }
        }
    }
    .SortManagement {
        padding: 20px 20px 10px;
        .SortManagement_inner {
            padding: 30px;
            width: calc(100% - 60px);
            min-height: calc(100vh - 155px);
            background: #fff;
            display: flex;
            flex-direction: column;
            .breadcrumb {
                align-items: center;
                justify-content: center;
                .el-breadcrumb {
                    font-size: 15px;
                    line-height: 2;
                }
            }
        }
    }
</style>

<style scoped>
    .Select {
        margin: 10px 0px;
    }
    .SortManagement .edit_btn {
        width: auto !important;
        background: rgba(80, 197, 217, 1);
        border-radius: 14px !important;
        color: #fff;
        border: #50C5D9;
    }

    .SortManagement .edit_btn:hover, .SortManagement .edit_btn:active, .SortManagement .edit_btn:focus {
        background: rgba(80, 197, 217, 1);
        color: #fff;
        border: #50C5D9;
    }

    .SortManagement .del_btn2 {
        width: auto !important;
        background: #E7E7E7;
        border-radius: 14px !important;
        color: #555;
        border: #E7E7E7;
    }

    .SortManagement .del_btn2:hover, .SortManagement .del_btn2:active, .SortManagement .del_btn2:focus {
        background: #E7E7E7;
        color: #555;
        border: #E7E7E7;
    }

    .SortManagement .del_btn {
        width: auto !important;
        background: #FF5B6C;
        border-radius: 14px !important;
        color: #fff;
        border: #FF5B6C;
    }

    .SortManagement .del_btn:hover, .SortManagement .del_btn:active, .SortManagement .del_btn:focus {
        background: #FF5B6C;
        color: #fff;
        border: #FF5B6C;
    }

    .Img {
        margin-top: 15px;
    }

    .video {
        margin-top: 20px;
    }
</style>

<style scoped>
    >>> .el-dialog__body {
        padding: 10px 20px;
        height: 800%;
    }

    >>> .el-form-item {
        margin-bottom: 0px;
    }

    >>> .el-form--label-top .el-form-item__label {
        float: none;
        display: inline-block;
        text-align: left;
        padding: 0;
        line-height: 20px;
    }

    >>> .el-form-item__error {
        padding-top: 0px;
        top: 95%;
        left: auto;
        right: 0;
    }
</style>
